import * as React from "react";

function SvgGameball(props, ref) {
  return (
    <svg
      id="Gameball_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 436.3 452"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {".Gameball_svg__st0{fill:#292c3b}.Gameball_svg__st3{fill:#e7633f}"}
      </style>
      <path
        d="M211.2 267.6H110.9l15.6-50.6-15.6-50.6h100.3v101.2z"
        fill="#a5452f"
      />
      <path d="M161.1 178.8l50.1-12.4V193l-50.1-14.2z" fill="#3d2b28" />
      <path
        className="Gameball_svg__st3"
        d="M161.1 282.5h151l26.7-103.7H161.1v103.7z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgGameball);
